import { Navigate, useParams } from 'react-router-dom';

import { LoaderComponent } from '@/shared/components/ui';
import { SaveCategoriaIncidente } from '../../shared/components/SaveCategoriaIncidente';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { useGetCategoriaIncidentes } from '@/shared/actions/erp/categoria-incidentes';

export interface ActCategoriaIncidentePagePageInterface {}

const ActCategoriaIncidentePagePage: React.FC<ActCategoriaIncidentePagePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_categoria_producto)

  const { id } = useParams();
  const { data, isLoading } = useGetCategoriaIncidentes(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_categoria_incidencia) return <Navigate to="/tickets-soporte-cliente/categoria-incidente" />;

  return <SaveCategoriaIncidente titlePage="Editar Categoria Incidencia" editCategoriaIncidencia={data.data} />;
};

export default ActCategoriaIncidentePagePage;
